<template>
  <div>
    <b-form @submit.prevent="submit()">
      <b-input-group>
        <b-form-input
          class="input_group"
          :class="inputClass"
          v-model="value"
          :disabled="disabled"
          :placeholder="placeholder"
          :autocomplete="autocomplete"
          @input="handleInput"
        />
        <b-input-group-append>
          <b-button
            size="sm"
            class="custom_btn width_50 my-input-group-append-button"
            :class="buttonClass"
            @click="submit()"
          >
            <mdicon :name="buttonIcon" size="20" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
  </div>
</template>
<script>
export default {
  name: "input-group",
  props: {
    type: {
      // input type
      type: String,
      default: "text",
    },
    placeholder: {
      // input placeholder
      type: String,
      default: "جستجو",
    },
    autocomplete: {
      // input autocomplete
      type: String,
      default: "off",
    },
    disabled: {
      // input disabled state
      type: Boolean,
      default: false,
    },
    inputClass: {
      // input parent class
      type: String,
      default: "",
    },
    buttonClass: {
      // input parent class
      type: String,
      default: "custom_btn--primary",
    },
    buttonIcon: {
      // input parent class
      type: String,
      default: "magnify",
    },
    clearInput: {
      // clear input of parent
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  watch: {
    clearInput(value) {
      this.value = null;
    },
  },
  methods: {
    handleInput(query) {
      this.$emit("input", query);

      /* guidance: run clear event of parent when input is empty */
      !query.length && this.$emit("reset");
    },
    submit() {
      this.$emit("submit", this.value);
    },
  },
};
</script>
